import gql from 'graphql-tag';

import { useSolQuery } from '@/hooks/useSolQuery';

import { fetcherSol } from '../sol-fetcher';
import { type HealthCenterGQLResponse } from './healthCenterType';

export const useHealthCenter = () => {
  const { data, error, isLoading } = useSolQuery<HealthCenterGQLResponse>({
    query: gql`
      query HealthCenterStatus {
        healthCenter {
          status {
            adVendors {
              createdAt
              createdBy {
                id
                name
              }
              isAvailable
              isComplete
              isFree
              label
            }
            channelMapping {
              isAvailable
              isComplete
              isFree
              label
              updatedAt
              updatedBy {
                id
                name
              }
            }
            customAudience {
              createdAt
              createdBy {
                id
                name
              }
              isAvailable
              isComplete
              isFree
              label
            }
            aiVisibility {
              label
              isAvailable
              isComplete
              isFree
              firstRunAt
            }
            onboardingProgress
            crm {
              isAvailable
              isComplete
              isFree
              label
              lastSynced
            }
            tag {
              isAvailable
              isComplete
              isFree
              label
              lastEventAt
              tagInstalledAt
            }
            tam {
              isAvailable
              isComplete
              isFree
              label
              updatedAt
              updatedBy {
                id
                name
              }
            }
            universalPixel {
              createdBy {
                id
                name
              }
              isAvailable
              isComplete
              isFree
              label
              lastCreatedAt
            }
            userAdmin {
              isAvailable
              isComplete
              isFree
              label
              lastUserAddedAt
            }
            vendorSpend {
              isAvailable
              isComplete
              isFree
              label
              spendInputThroughAt
              lastUpdatedBy {
                id
                name
              }
            }
          }
        }
      }
    `,
  });

  return {
    healthCenterData: data?.healthCenter.status,
    isLoading,
    error,
  };
};

export const completeSetupWelcome = () =>
  fetcherSol<
    never,
    {
      instances: { completeSetupWelcome: boolean };
    }
  >({
    query: gql`
      mutation CompleteSetupWelcome {
        instances {
          completeSetupWelcome
        }
      }
    `,
  });
